import { mapMutations } from 'vuex';
import { debounce } from '@/helpers/timeout';

const breakpointsMixin = {
  methods: {
    ...mapMutations({
      setScreenWidth: 'breakpoints/setScreenWidth',
    }),

    updateScreenWidthDebounced: debounce(function () {
      this.setScreenWidth((window || {}).innerWidth);
    }, 50),
  },
  mounted() {
    window.addEventListener('resize', this.updateScreenWidthDebounced);
  },
  destroyed() {
    window.removeEventListener('resize', this.updateScreenWidthDebounced);
  },
};

export default breakpointsMixin;
